import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { CreateButton } from '../../buttons';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, SimpleShowLayout } from '../../controllers';
import { LinkField, TextField } from '../../fields';
import { BooleanInput, ReferenceInput, SearchInput, TeamMemberSelectInput, TextInput } from '../../inputs';
import staff_team_memberships from './staff_team_memberships';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="name"
          required
        />
        <TeamMemberSelectInput
          source="leader_id"
        />
        <ReferenceInput
          source="location_id"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        {...props}
      >
        <TextInput
          source="name"
          required
        />
        <TeamMemberSelectInput
          source="leader_id"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <LinkField
          reference="users"
          source="leader_id"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="id"
        />
        <TextField
          source="name"
        />
        <LinkField
          reference="users"
          source="leader_id"
        />

        <NestedResourceList
          reference="staff_team_memberships"
        >
          <LinkField
            source="user_id"
          />
        </NestedResourceList>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >

        <NestedResourceList
          reference="staff_team_memberships"
        >
          <LinkField
            source="user_id"
          />
          <TextField
            source="title"
          />
        </NestedResourceList>

      </SimpleShowLayout>
    ),
  },
  resources: {
    staff_team_memberships
  },
};
